export class FormaPago {
    idFormaPago: number;
    monto: number;
    idWayToPay?: number;
    nombre?: string;
}



// WEBPACK FOOTER //
// ./src/app/models/forma-pago.ts